// Centralized event-lifecycle helpers. The 7-state machine is:
//   draft → prep → registration → locked → live → endex → closed
// (with locked ↔ registration backtrack and closed → endex reopen-for-fix).
//
// Per the Bug 33 spec:
//   draft                  → no content creation (placeholder phase)
//   prep/registration/locked → GMs can queue intel, bounties, FRAGOs,
//                              equipment, checkpoints (setting up the event)
//   live                   → everything active
//   endex/closed           → read-only

// True when the event is in a phase that allows GMs to create or queue
// new content (intel triggers, bounties, FRAGOs, equipment, checkpoints).
export const canCreateContent = (status) =>
  ['prep','registration','locked','live'].includes(status)

// True when the event allows live in-game actions (kill scans, intel
// scans, bounty pursuits). Strictly limited to LIVE.
export const isPlayPhase = (status) => status === 'live'

// True when the event is over and changes should be blocked unless an
// admin is forcing a correction.
export const isTerminal = (status) =>
  status === 'closed' || status === 'cancelled'
